import { render, staticRenderFns } from "./SupportHubItems.vue?vue&type=template&id=5d28e784&"
import script from "./SupportHubItems.vue?vue&type=script&lang=js&"
export * from "./SupportHubItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports